
<template>
    <div>
        <v-expansion-panels v-model="panel" multiple :disabled="disabled">
            <v-expansion-panel >
                <v-expansion-panel-header>
                    <div>
                        <p style="margin-bottom: 9px">Service (MA)</p>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="!loading">
                    <v-row>
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-row>
                            <v-col cols="5" class="mt-2 text-center">
                                <p>Implement MA start date</p>
                            </v-col>
                            <v-col cols="7">
                                <v-menu
                                v-model="ma_start_date_menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="readonly"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="detailItems.ma_start_date"
                                            append-icon="event"
                                            readonly
                                            v-on="on"
                                            name="ma-start-date"
                                            dense
                                            outlined
                                            hide-details
                                            :color="color"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="detailItems.ma_start_date"
                                        @input="ma_start_date_menu = false"
                                        @change="DataChange"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" class="mt-2 text-center">
                                <p>Implement MA end date</p>
                            </v-col>
                            <v-col cols="7">
                                <v-menu
                                v-model="ma_end_date_menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="readonly"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="detailItems.ma_end_date"
                                            append-icon="event"
                                            readonly
                                            v-on="on"
                                            name="ma-end-date"
                                            dense
                                            outlined
                                            hide-details
                                            :color="color"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="detailItems.ma_end_date"
                                        @input="ma_end_date_menu = false"
                                        @change="DataChange"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" class="mt-2 text-center">
                                <p>Implement MA Period</p>
                            </v-col>
                            <v-col cols="7">
                                <v-text-field v-model="detailItems.ma_period" dense outlined hide-details suffix="Month(s)" type="number" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import moment from "moment";
import data_mapping_json from "../../json/sale_orders/service_ma.json";
import { readonly } from "vue";


export default {
    data() {
        return {
            loading: false,
            readonly: this.ro,
            panel: [0],
            color: "",
            data: JSON.parse(JSON.stringify(this.dt)) || {},
            detailItems: {},
            ma_start_date_menu: false,
            ma_end_date_menu: false,
            disabled: false,
        };
    },
    props: ["ro", "dt"],
    methods: {
        DataChange() {
            if ( this.detailItems["ma_period"] != null && this.detailItems["ma_period"] != "" && !isNaN(this.detailItems["ma_period"])) {
                this.detailItems["ma_period"] = parseFloat(this.detailItems["ma_period"]).toFixed(2)
            }
            this.$emit("update-data", this.detailItems, "service_ma");
        },
        PrepareData() {
            return new Promise(async (resolve, reject) => {
                let obj = {};
                for (let dt_json in data_mapping_json) {
                if (data_mapping_json[dt_json] != "") {
                    if (dt_json.includes("date")) {
                    if (this.data[data_mapping_json[dt_json]] != null) {
                        obj[dt_json] = moment(
                        JSON.parse(
                            JSON.stringify(this.data[data_mapping_json[dt_json]])
                        )
                        ).format("YYYY-MM-DD");
                    } else {
                        obj[dt_json] = null;
                    }
                    } else {
                    if (this.data[data_mapping_json[dt_json]] != undefined) {
                        obj[dt_json] = JSON.parse(
                        JSON.stringify(this.data[data_mapping_json[dt_json]])
                        );
                    } else {
                        obj[dt_json] = null;
                    }
                    }
                }
                }
                resolve(obj);
            });
        },
    },
    created() {
        this.loading = true;
        this.PrepareData().then((response) => {
            this.detailItems = response;
            this.loading = false;
        });
    },
}
</script>
<style>
#header-text {
  font-size: 30px;
  display: inline-block;
}

@media (min-width: 0px) {
  .col.grid-5-custom {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .col.grid-5-custom {
    width: 50%;
    max-width: 50%;
    flex-basis: 50%;
  }
}

@media (min-width: 960px) {
  .col.grid-5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
}
</style>